import { allEnumValues } from './helper.js';
import { LanguageCode } from './language_code.js';

export function name(languageCode: LanguageCode): string {
  switch (languageCode) {
    case LanguageCode.EN_US:
      return 'English (US)';
    case LanguageCode.AR_SA:
      return 'Arabic (SA)';
    case LanguageCode.EN_GB:
      return 'English (UK)';
    case LanguageCode.FR_CA:
      return 'French (CA)';
    case LanguageCode.ES_US:
      return 'Spanish (US)';
    case LanguageCode.ZH_CN:
      return 'Chinese (Simplified)';
    case LanguageCode.JA_JP:
      return 'Japanese';
    case LanguageCode.KO_KR:
      return 'Korean';
    case LanguageCode.PT_BR:
      return 'Portuguese (Brazil)';
    case LanguageCode.VI_VN:
      return 'Vietnamese';
    case LanguageCode.DE_DE:
      return 'German';
    case LanguageCode.IT_IT:
      return 'Italian';
  }
}

export function localizedName(languageCode: LanguageCode): string {
  switch (languageCode) {
    case LanguageCode.EN_US:
      return 'English';
    case LanguageCode.AR_SA:
      return 'العربية';
    case LanguageCode.EN_GB:
      return 'English';
    case LanguageCode.FR_CA:
      return 'Français';
    case LanguageCode.ES_US:
      return 'Español';
    case LanguageCode.ZH_CN:
      return '中文';
    case LanguageCode.JA_JP:
      return '日本語';
    case LanguageCode.KO_KR:
      return '한국어';
    case LanguageCode.PT_BR:
      return 'Português';
    case LanguageCode.VI_VN:
      return 'Tiếng Việt';
    case LanguageCode.DE_DE:
      return 'Deutsch';
    case LanguageCode.IT_IT:
      return 'Italiano';
  }
}

export function supplementLanguages(): LanguageCode[] {
  return allEnumValues<LanguageCode>(LanguageCode).filter((languageCode) => {
    return languageCode !== LanguageCode.EN_US;
  });
}

const rtlLanguageCodeSet = new Set<LanguageCode>([LanguageCode.AR_SA]);

export function isRtl(languageCode: LanguageCode): boolean {
  return rtlLanguageCodeSet.has(languageCode);
}
